import api from '@/api/order'
import swal from 'sweetalert2'

export default {
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {
        async customerOrder({ commit }, payload) {


            let _swalSuccess = (icon, title) => {
                return swal.fire({
                    toast: true,
                     icon: icon,
                    title: title,
                    showConfirmButton: icon === 'error',
                    timer: icon != 'error' ? 2500 : 0,
                });
            }

            let _swalQuestion = async (action) => {
                return await swal.fire({
                    toast:true,
                    title: `Are you sure you want to ${action}?`,
                    icon: "warning",
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete",
                    cancelButtonText: "No",
                    customClass: {
                        confirmButton: 'sw-white-text-button',
                        cancelButton: 'sw-white-text-button',
                    }
                });

            }

            return new Promise(async (resolve, reject) => {
                let cancel = false;
                if (payload.method == 'delete') {
                    let res = await _swalQuestion('delete');
                    cancel = !res.isConfirmed;
                }

                if (!cancel) {
                    await api.customerOrder(payload).then().then(response => {
                        _swalSuccess(response.data.message.icon, response.data.message.message, false)
                        resolve(response)
                        commit('NEW_DATA_STORE', true)

                    }).catch(error => {
                        _swalSuccess('error', JSON.stringify(error), false)
                        reject(error)
                    })
                }

            })
        }
    },
}